import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';
import { runOptimisticCachedQueryPatches } from './queryCacheUtils';

const toProductFormData = (product = {}) => {
  const fd = new FormData();
  Object.entries(product).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;

    if (key === 'images') {
      const list = Array.isArray(value) ? value : [value];
      list
        .filter(Boolean)
        .forEach((file) => fd.append('product[images][]', file));
      return;
    }

    fd.append(`product[${key}]`, value);
  });
  return fd;
};

export const productApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createProduct: builder.mutation({
      query: (product) => ({
        url: '/api/products',
        method: 'POST',
        body: toProductFormData(product),
      }),
    }),
    getProducts: builder.query({
      query: (args = {}) => ({
        url: '/api/products',
        params: buildListQueryParams(args),
      }),
      providesTags: ['Products'],
    }),
    updateProduct: builder.mutation({
      query: ({ id, ...product }) => ({
        url: `/api/products/${id}`,
        method: 'PUT',
        body: toProductFormData(product),
      }),
      invalidatesTags: ['Products'],
    }),
    updateProductStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/api/products/${id}/update_status`,
        method: 'PATCH',
        body: { status },
      }),
      async onQueryStarted({ id, status }, { dispatch, getState, queryFulfilled }) {
        await runOptimisticCachedQueryPatches({
          dispatch,
          getState,
          queryFulfilled,
          endpointName: 'getProducts',
          updateDraft: (draft) => {
            const list = draft?.data;
            if (!Array.isArray(list)) return;
            const row = list.find((p) => Number(p.id) === Number(id));
            if (row) row.status = status;
          },
        });
      },
    }),
  }),
});

export const {
  useCreateProductMutation,
  useGetProductsQuery,
  useUpdateProductMutation,
  useUpdateProductStatusMutation,
} = productApi;

